import React, { createContext, useContext, useState } from 'react';

const SidebarTabContext = createContext();

export function SidebarTabProvider({ children }) {
  const [activeTab, setActiveTab] = useState('mis-preguntas');
  return (
    <SidebarTabContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </SidebarTabContext.Provider>
  );
}

export function useSidebarTab() {
  const ctx = useContext(SidebarTabContext);
  if (!ctx) throw new Error('useSidebarTab debe usarse dentro de SidebarTabProvider');
  return ctx;
}
